import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
@Component({
  selector: 'fgb-mixed-loyalty-nav',
  templateUrl: './mixed-loyalty-nav.component.html',
  styleUrls: ['./mixed-loyalty-nav.component.scss'],
})
export class MixedLoyaltyNavComponent implements OnInit {
  screenType = ScreenType;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {}

  isActive(url: string): boolean {
    // Check if the route contains query params.
    const hasQueryParams = Object.keys(this.route.snapshot.queryParams)?.length > 0;
    return this.router.isActive(url, true) || (this.router.isActive(url, false) && hasQueryParams);
  }
}
